export const getPaymentBrand = (paymentBrand: string): { alias: string; url: string } => {
  const brand = paymentBrand.toLowerCase();

  return paymentsBrands[brand];
};

export const paymentsBrands = {
  credit: {
    alias: 'Crédito',
    url: '/img/icon-cartao.svg',
  },
  credito: {
    alias: 'Crédito',
    url: '/img/icon-cartao.svg',
  },
  'múltiplos cartões': {
    alias: 'Crédito',
    url: '/img/icon-cartao.svg',
  },
  ['boleto bancário']: {
    alias: 'Boleto',
    url: '/img/boleto.svg',
  },
  boleto: {
    alias: 'Boleto',
    url: '/img/boleto.svg',
  },
  desconhecido: {
    alias: 'Crédito',
    url: '/img/icon-cartao.svg',
  },
  discover: {
    alias: 'Crédito',
    url: '/img/icon-cartao.svg',
  },
  paypal: {
    alias: 'PayPal',
    url: '/img/paypal.svg',
  },
  mastercard: {
    alias: 'Mastercard',
    url: '/img/mastercard.svg',
  },
  visa: {
    alias: 'Visa',
    url: '/img/visa.svg',
  },
  Elo: {
    alias: 'Elo',
    url: '/img/elo.svg',
  },
  elo: {
    alias: 'Elo',
    url: '/img/elo.svg',
  },
  hypercard: {
    alias: 'Hipercard',
    url: '/img/hiper.svg',
  },
  hipercard: {
    alias: 'Hipercard',
    url: '/img/hiper.svg',
  },
  hiper: {
    alias: 'Hiper',
    url: '/img/hiper.svg',
  },
  ewallet: {
    alias: 'eWallet',
    url: '/img/paypal2.svg',
  },
  amex: {
    alias: 'Amex',
    url: '/img/othercard.svg',
  },
  diners: {
    alias: 'Dinners',
    url: '/img/dinners.svg',
  },
  'saldo eduzz': {
    alias: 'Saldo Eduzz',
    url: '/img/eduzzBalance.svg',
  },
  pix: {
    alias: 'Pix',
    url: '/img/pix.svg',
  },
};

export const constants = {
  create: { alias: 'Criação' },
  receive: { alias: 'Pagamento' },
  click: { alias: 'Clique' },
  producer: { alias: 'Produtor' },
  coproducer: { alias: 'Co-produtor' },
  affiliate: { alias: 'Afiliado' },
  A: { alias: 'Assinatura' },
  N: { alias: 'Única' },
  G: { alias: 'Gratuito' },
  next: {
    alias: 'NEXT',
    url: 'https://next.eduzz.com',
  },
  INVOICES: 'INVOICES',
  CUSTOMER: 'CUSTOMER',
  PAYMENT_METHOD: 'PAYMENT_METHOD',
  AFFILIATES: 'AFFILIATES',
  MAIN_PRODUCTS: 'MAIN_PRODUCTS',
  TYPE_GAIN: 'TYPE_GAIN',
  UTMS: 'UTMS',
  VARIATIONS: 'VARIATIONS',
  COUPONS: 'COUPONS',
  STATUS: 'STATUS',
  PERIOD: 'PERIOD',
  OTHERS: 'OTHERS',
  SALE_FROM: 'SALE_FROM',
  TYPE_CHARGING: 'TYPE_CHARGING',
  CONTRACTS: 'CONTRACTS',

  // menu control

  // example:

  // menu: {
  //   label: 'My title',
  //   icon: 'my_icon',
  //   active: 'myhash',
  //   href: 'mylink',
  //   isRouter: false, // forward to direct href without opening submenu
  //   submenu: [
  //     { label: 'My page', href: '/producer/sales' },
  //   ],
  //   isRelated: [
  //     '/producer/sales',
  //     '/producer/invoice/details',
  //   ],
  // },

  // PRODUCT PARTNERS
  productPartners: {
    alumy: 36,
    blinket: 28,
  },

  // PAYMENT STATUS
  PAYMENT_STATUS: {
    OPEN: 1,
    EXPIRED: 10,
    WAITING_PAYMENT: 15,
  },

  PAYMENT_METHODS: {
    BANKSLIP: 1,
    CREDIT_CARD_ELO: 24,
    DUPLICATED_CREDIT_CARD_ELO: 10,
  },

  // PRODUCT TYPES
  CLIENTS_CAN_EDIT_OVERDUE_LIMIT: [273925, 27270338],
  INFO: 1,
  SERVICE: 2,
  PHYSICAL: 3,
  TICKET: 4,
  BLINKET: 28,
  ALUMY: 36,
  links: {
    MoreInfoDashElite: 'https://programaelite.eduzz.com/',
    OldCheckout: 'https://g.eduzz.com/',
    CustomizeCheckout: 'https://adminsun.eduzz.com/',
    OrbitPage: 'https://app.orbitpag.es/eduzz-links',
    SalesPage: 'https://p.eduzz.com/',
  },
  TRANSFER_RATE_VALUE: 9.0,
  MINIMUN_VALUE_FOR_TRANSFER: 100,
  MIN_LINES_EXPORT_BACKBROUND_SALES: 1000,
  MAUTIC_AUTORESPONDER_ID: 35,
};

export const PF_TRANSFER_LIMIT = 1900;
export const MIN_TRANSFER = 20;
export const MIN_TRANSFER_INTERNATIONAL = 5500;

export const EXPORT_MAX_LINES_SIZE = 25000;
export const EXPORT_MAX_LINES_TITLE = 'Este relatório é muito grande =/';
export const EXPORT_MAX_LIZES_MESSAGE = `
  Os robôzinhos do nosso sistema ainda não conseguem exportar relatórios com mais de 25 mil linhas.
  Estamos treinando eles para que isso seja possível em breve.
  Experimente pesquisas com resultados menores e dará tudo certo ;)
`;

export const PARTNER_CODE = {
  alumy: 36,
  blinket: 28,
};

export enum ERebrandingFonts {
  OPENSANS = '"Roboto","Helvetica Neue", "Arial",sans-serif',
}

export enum ERebrandingColors {
  CONTRAST_TEXT = '#fff',
  DARK = '#37474F',
  LIGHT = '#9EB5D9',
  MAIN = '#0D2772',
}

export const FINANCIAL_BLOCK_TOOLTIP_MESSAGE =
  'Para solicitação de transferência bancaria contate suporte@eduzz.com ou contate seu gerente de contas.';

export const ANTICIPATION_ACCESS_BLOCK_TOOLTIP_MESSAGE =
  'Ainda não é possível antecipar suas vendas. Para utilizar essa funcionalidade, aguarde o prazo de 30 dias a partir da data de pagamento da sua primeira venda.';

export const ANTICIPATION_BLOCK_CHARGEBACK_TOOLTIP_MESSAGE = 'Antecipação bloqueada por alto índice de chargeback';
